import React, { useEffect, useState } from 'react';
import SelectOrganizations from '../../common/SelectOrganizations';
import { useLocation, useHistory } from 'react-router-dom';
import useUserRoles from '../../../hooks/useUserRoles';
import { useTranslation } from 'react-i18next';
import { RootState, useSelector } from '../../../redux/store';
import type { OrganizationType } from '../../../types/organization';

const AddCondition = (): React.ReactElement => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const { isAdminOrPoweruser } = useUserRoles();
  const { organizations } = useSelector((state: RootState) => state.organization);
  const [selectedOptions, setSelectedOptions] = useState<OrganizationType[]>([]);
  const optionsFilter = (options: OrganizationType[]): OrganizationType[] => options.filter((option) => !option.isTradingCompany);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (organizations) {
      const params = new URLSearchParams(location.search);
      const ids: string | null = decodeURIComponent(params.get('organizationIds'));
      // カンマ区切りのnumeric stringを数値化＆バリデーション
      const selectedIds: number[] = ids
        ? ids
            .split(',')
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id))
        : [];
      const selectedOrganizations: OrganizationType[] = organizations.filter((org) => selectedIds.includes(org.id));
      // console.log(ids, selectedIds, selectedOrganizations);
      setSelectedOptions(selectedOrganizations);
    }
  }, [location.search, organizations]);

  // EVENT HANDLER
  // ================================================================================
  /**
   * プルダウンから組織を選んだとき
   */
  const handleSelectOrganization = (options: OrganizationType[]): void => {
    if (isAdminOrPoweruser) {
      const ids: string = options.map((option) => option.id).join(',');
      // console.log(ids);
      const params = new URLSearchParams(location.search);
      params.set('organizationIds', encodeURIComponent(ids));
      history.push({ search: params.toString() });
    } else {
      // do nothing
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      {isAdminOrPoweruser && (
        <div id="selectOrganizationConditionContainer" className="d-flex align-items-center">
          <label className="mb-0" htmlFor="selectOrganizationCondition">
            {t('millSheet.searchWithCriteria')}：
          </label>
          <SelectOrganizations
            id={'selectOrganizationCondition'}
            name={'selectOrganizationCondition'}
            placeholder={t('dropdown.not')}
            isClearable={true}
            displayTradingCompany={false}
            selected={selectedOptions}
            optionsFilter={optionsFilter}
            onChange={handleSelectOrganization}
          />
        </div>
      )}
    </>
  );
};

export default AddCondition;
